(() => {
  const STORAGE_KEY = 'artex_quote_list_v1';

  function getList() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const data = raw ? JSON.parse(raw) : [];
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(list)
    );

    updateAll();
  }

  function itemKey(item) {
    return String(
      item.sku ||
      item.productId ||
      item.url ||
      item.title ||
      ''
    ).trim();
  }

  function addItem(item) {
    const list = getList();
    const key = itemKey(item);

    const existing = list.find(
      x => itemKey(x) === key
    );

    if (existing) {
      existing.quantity =
        Math.max(
          1,
          Number(existing.quantity || 1) +
          Number(item.quantity || 1)
        );
    } else {
      list.push({
        productId: item.productId || '',
        title: item.title || '',
        sku: item.sku || '',
        url: item.url || '',
        quantity: Math.max(
          1,
          Number(item.quantity || 1)
        )
      });
    }

    saveList(list);

    return list;
  }

  function removeItem(index) {
    const list = getList();

    if (index >= 0 && index < list.length) {
      list.splice(index, 1);
      saveList(list);
    }

    return list;
  }

  function setQuantity(index, quantity) {
    const list = getList();

    if (index >= 0 && index < list.length) {
      list[index].quantity =
        Math.max(
          1,
          Number(quantity || 1)
        );

      saveList(list);
    }

    return list;
  }

  function clearList() {
    localStorage.removeItem(STORAGE_KEY);
    updateAll();
  }

  function totalQuantity(list = getList()) {
    return list.reduce(
      (sum, item) =>
        sum +
        Math.max(
          1,
          Number(item.quantity || 1)
        ),
      0
    );
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function updateBadges() {
    const count = totalQuantity();

    document
      .querySelectorAll('[data-artex-quote-count]')
      .forEach(el => {
        el.textContent = String(count);
        el.hidden = false;
      });

    document
      .querySelectorAll('[data-artex-quote-link]')
      .forEach(el => {
        el.hidden = count === 0;
      });
  }

  function buildMailText(list) {
    return list.map((item, index) => {

      const lines = [
        `${index + 1}. ${item.title || 'Prodotto'}`,
        `Codice/SKU: ${item.sku || 'N/D'}`,
        `Quantità: ${Math.max(
          1,
          Number(item.quantity || 1)
        )}`
      ];

      if (item.url) {
        lines.push(`Link: ${item.url}`);
      }

      return lines.join('\n');

    }).join('\n\n');
  }

  function setupQuotePage() {
    const root =
      document.querySelector(
        '[data-artex-quote-page]'
      );

    if (!root) return;

    const listEl =
      root.querySelector(
        '[data-artex-quote-items]'
      );

    const emptyEl =
      root.querySelector(
        '[data-artex-quote-empty]'
      );

    const hiddenEl =
      root.querySelector(
        '[data-artex-quote-hidden]'
      );

    const submitBtn =
      root.querySelector(
        '[data-artex-quote-submit]'
      );

    const clearBtn =
      root.querySelector(
        '[data-artex-quote-clear]'
      );

    const countText =
      root.querySelector(
        '[data-artex-quote-total]'
      );

    const render = () => {
      const list = getList();

      if (hiddenEl) {
        hiddenEl.value =
          buildMailText(list);
      }

      if (submitBtn) {
        submitBtn.disabled =
          list.length === 0;
      }

      if (emptyEl) {
        emptyEl.hidden =
          list.length > 0;
      }

      if (clearBtn) {
        clearBtn.hidden =
          list.length === 0;
      }

      if (countText) {
        countText.textContent =
          String(totalQuantity(list));
      }

      if (!listEl) return;

      if (!list.length) {
        listEl.innerHTML = '';
        return;
      }

      listEl.innerHTML =
        list.map((item, index) => `
          <article
            class="artex-quote-item"
            data-quote-index="${index}"
          >

            <div class="artex-quote-item__info">

              <h3 class="artex-quote-item__title">

                ${
                  item.url
                    ? `<a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>`
                    : escapeHtml(item.title)
                }

              </h3>

              <p class="artex-quote-item__sku">
                <strong>Codice:</strong>
                ${escapeHtml(
                  item.sku || 'N/D'
                )}
              </p>

            </div>

            <div class="artex-quote-item__actions">

              <label
                class="artex-quote-item__label"
                for="quote-qty-${index}"
              >
                Quantità
              </label>

              <div class="artex-quote-qty">

                <button
                  type="button"
                  class="artex-quote-qty__btn"
                  data-quote-minus="${index}"
                  aria-label="Riduci quantità"
                >
                  −
                </button>

                <input
                  id="quote-qty-${index}"
                  class="artex-quote-qty__input"
                  type="number"
                  min="1"
                  step="1"
                  value="${Math.max(
                    1,
                    Number(item.quantity || 1)
                  )}"
                  data-quote-qty="${index}"
                >

                <button
                  type="button"
                  class="artex-quote-qty__btn"
                  data-quote-plus="${index}"
                  aria-label="Aumenta quantità"
                >
                  +
                </button>

              </div>

              <button
                type="button"
                class="artex-quote-remove"
                data-quote-remove="${index}"
              >
                Rimuovi
              </button>

            </div>

          </article>
        `).join('');
    };

    root._artexQuoteRender = render;

    if (
      root.dataset.artexQuoteInitialized !== 'true'
    ) {
      root.dataset.artexQuoteInitialized = 'true';

      root.addEventListener(
        'click',
        event => {

          const minus =
            event.target.closest(
              '[data-quote-minus]'
            );

          const plus =
            event.target.closest(
              '[data-quote-plus]'
            );

          const remove =
            event.target.closest(
              '[data-quote-remove]'
            );

          if (minus) {
            const index =
              Number(
                minus.dataset.quoteMinus
              );

            const list = getList();

            if (list[index]) {
              setQuantity(
                index,
                Math.max(
                  1,
                  Number(
                    list[index].quantity || 1
                  ) - 1
                )
              );
            }
          }

          if (plus) {
            const index =
              Number(
                plus.dataset.quotePlus
              );

            const list = getList();

            if (list[index]) {
              setQuantity(
                index,
                Number(
                  list[index].quantity || 1
                ) + 1
              );
            }
          }

          if (remove) {
            removeItem(
              Number(
                remove.dataset.quoteRemove
              )
            );
          }

        }
      );

      root.addEventListener(
        'change',
        event => {

          const input =
            event.target.closest(
              '[data-quote-qty]'
            );

          if (!input) return;

          setQuantity(
            Number(
              input.dataset.quoteQty
            ),
            Math.max(
              1,
              Number(input.value || 1)
            )
          );

        }
      );

      if (clearBtn) {
        clearBtn.addEventListener(
          'click',
          () => {
            clearList();
          }
        );
      }

      const form =
        root.querySelector('form');

      if (form) {
        form.addEventListener(
          'submit',
          event => {

            const list = getList();

            if (!list.length) {
              event.preventDefault();

              alert(
                'Aggiungi almeno un prodotto alla richiesta.'
              );

              return;
            }

            if (hiddenEl) {
              hiddenEl.value =
                buildMailText(list);
            }

          }
        );
      }
    }

    render();
  }

  function updateAll() {
    updateBadges();

    const root =
      document.querySelector(
        '[data-artex-quote-page]'
      );

    if (
      root &&
      typeof root._artexQuoteRender === 'function'
    ) {
      root._artexQuoteRender();
    }
  }

  document.addEventListener(
    'click',
    event => {

      const button =
        event.target.closest(
          '[data-artex-quote-add]'
        );

      if (!button) return;

      event.preventDefault();

      const item = {
        productId:
          button.dataset.productId || '',

        title:
          button.dataset.productTitle || '',

        sku:
          button.dataset.productSku || '',

        url:
          button.dataset.productUrl ||
          window.location.href,

        quantity: 1
      };

      addItem(item);

      if (!button.dataset.originalText) {
        button.dataset.originalText =
          button.textContent.trim();
      }

      button.textContent =
        '✓ AGGIUNTO ALLA RICHIESTA';

      button.classList.add(
        'artex-quote-added'
      );

      clearTimeout(
        button._artexQuoteTimer
      );

      button._artexQuoteTimer =
        setTimeout(() => {

          button.textContent =
            button.dataset.originalText ||
            'AGGIUNGI ALLA RICHIESTA';

          button.classList.remove(
            'artex-quote-added'
          );

        }, 1800);

    }
  );

  document.addEventListener(
    'DOMContentLoaded',
    () => {

      const success =
        document.querySelector(
          '[data-artex-quote-success="true"]'
        );

      if (success) {
        localStorage.removeItem(
          STORAGE_KEY
        );
      }

      updateBadges();
      setupQuotePage();

    }
  );

  window.ArtexQuoteList = {
    getList,
    addItem,
    removeItem,
    setQuantity,
    clearList
  };

})();